import React from 'react';
import { motion } from 'framer-motion';

const CompanyCredentials = () => {
  const foundationElements = [
    {
      title: "Agricultural Expertise",
      description: "Deep knowledge of Nigerian agriculture",
      icon: "🌾",
      status: "Foundation"
    },
    {
      title: "Quality Commitment",
      description: "Unwavering dedication to product quality",
      icon: "🏆",
      status: "Core Value"
    },
    {
      title: "Nigerian Sourcing",
      description: "Direct relationships with local farmers",
      icon: "🤝",
      status: "Priority"
    },
    {
      title: "Value-Added Processing",
      description: "Modern processing for premium products",
      icon: "⚙️",
      status: "Capability"
    },
    {
      title: "Transparent Operations",
      description: "Open communication about our journey",
      icon: "🌟",
      status: "Promise"
    },
    {
      title: "Sustainable Practices",
      description: "Environmental responsibility",
      icon: "🌍",
      status: "Commitment"
    }
  ];

  return (
    <section className="py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl">
            Built on Strong Foundations
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            As a new company, we're building our agricultural export business on solid principles and genuine commitments.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {foundationElements.map((element, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: index * 0.15, ease: "easeOut" }}
              className="bg-gray-50 rounded-lg p-6 text-center hover:shadow-lg transition-shadow duration-500"
            >
              <div className="text-4xl mb-4">{element.icon}</div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                {element.title}
              </h3>
              <p className="text-gray-600 mb-3">{element.description}</p>
              <span className="inline-block bg-green-100 text-green-800 text-sm px-3 py-1 rounded-full">
                {element.status}
              </span>
            </motion.div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-6">
            Building credibility through honest business practices and quality agricultural exports
          </p>
          <div className="flex flex-col sm:flex-row justify-center items-center space-y-2 sm:space-y-0 sm:space-x-4 md:space-x-6 lg:space-x-8 opacity-60">
            <div className="text-lg sm:text-xl md:text-2xl font-bold text-green-600">Nigerian</div>
            <div className="text-lg sm:text-xl md:text-2xl font-bold text-green-600">Agriculture</div>
            <div className="text-lg sm:text-xl md:text-2xl font-bold text-green-600">Quality</div>
            <div className="text-lg sm:text-xl md:text-2xl font-bold text-green-600">Trust</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanyCredentials; 